import {
  DataTableAction,
  EllipsisMenuButton,
  Menu,
  MenuContent,
  MenuTrigger,
} from '@optiaxiom/react';

import type { Notification } from '../../../types';

type ActionsCellProps = {
  notification: Notification;
  onMarkRead: (id: string) => void;
  onMarkUnread: (id: string) => void;
  onDelete: (id: string) => void;
};

export function ActionsCell({
  notification,
  onMarkRead,
  onMarkUnread,
  onDelete,
}: ActionsCellProps) {
  const options = [
    notification.is_read
      ? { label: 'Mark as unread', execute: () => onMarkUnread(notification.id) }
      : { label: 'Mark as read', execute: () => onMarkRead(notification.id) },
    {
      label: 'Delete',
      intent: 'danger' as const,
      execute: () => onDelete(notification.id),
    },
  ];

  return (
    <Menu options={options}>
      <DataTableAction asChild visible="always">
        <MenuTrigger asChild>
          <EllipsisMenuButton appearance="subtle" aria-label="Options" />
        </MenuTrigger>
      </DataTableAction>
      <MenuContent />
    </Menu>
  );
}
